import { Card, CardHeader, CardTitle, CardContent } from "@repo/o37-ui";

export default function Home() {
  const userRole = localStorage.getItem('app_role');

  return (
    <div className="w-full">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold mb-2">Welcome Home</h1>
        <p className="text-neutral-500">Select a module from the navigation bar to get started.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card>
            <CardHeader>
                <CardTitle>Status</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-sm text-neutral-600">
                    System is operational.
                </div>
            </CardContent>
        </Card>
        
        {userRole === 'super_admin' && (
             <Card>
                <CardHeader>
                    <CardTitle>Admin Access</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="text-sm text-neutral-600">
                        You have full access to all modules.
                    </div>
                </CardContent>
            </Card>
        )}
      </div>
    </div>
  );
}
